import { Fragment } from 'react';
import Email from "../decorators/Email";
import Link from "../decorators/Link";
import UserTag from "../decorators/UserTag";
import { findWithRegex, REGEX_EMAIL, REGEX_TAG, REGEX_URL } from "../regex";
import { jsx as _jsx } from "react/jsx-runtime";
var decoratorsByName = {
  email: {
    REGEX: REGEX_EMAIL,
    Decorator: Email,
    nextDecoratorName: 'link'
  },
  link: {
    REGEX: REGEX_URL,
    Decorator: Link,
    nextDecoratorName: 'user-tag'
  },
  'user-tag': {
    REGEX: REGEX_TAG,
    Decorator: UserTag
  }
};
var ParsedDecoratorChildren = function ParsedDecoratorChildren(_ref) {
  var text = _ref.text,
    _ref$decoratorToBePar = _ref.decoratorToBeParsed,
    decoratorToBeParsed = _ref$decoratorToBePar === void 0 ? 'email' : _ref$decoratorToBePar,
    isDark = _ref.isDark;
  var _decoratorsByName$dec = decoratorsByName[decoratorToBeParsed],
    REGEX = _decoratorsByName$dec.REGEX,
    Decorator = _decoratorsByName$dec.Decorator,
    nextDecoratorName = _decoratorsByName$dec.nextDecoratorName;
  var children = [];
  var lastIndex = 0;
  findWithRegex(REGEX, text, function (startIndex, endIndex) {
    // Push the preceding text if there is any
    if (startIndex > lastIndex) {
      var precedingText = text.substring(lastIndex, startIndex);

      /*
       * The text that didn't match with the given regex might need to be reevaluated with another decorator.
       * This is why we need to return the same ParsedDecoratorChildren component only with the preceding text when a nextDecoratorName is provided.
       */
      if (nextDecoratorName) {
        children.push( /*#__PURE__*/_jsx(ParsedDecoratorChildren, {
          text: precedingText,
          decoratorToBeParsed: nextDecoratorName,
          isDark: isDark
        }, precedingText));
      } else {
        children.push(precedingText);
      }
    }
    var matchedText = text.substring(startIndex, endIndex);
    children.push( /*#__PURE__*/_jsx(Decorator, {
      decoratedText: matchedText,
      isDark: isDark
    }, matchedText));
    lastIndex = endIndex;
  });
  // Push the rest of the text if there is any
  if (lastIndex < text.length) {
    var remainingText = text.substring(lastIndex);

    /*
     * The text that didn't match with the given regex might need to be reevaluated with another decorator.
     * This is why we need to return the same ParsedDecoratorChildren component only with the remaining text when a nextDecoratorName is provided.
     */
    if (nextDecoratorName) {
      children.push( /*#__PURE__*/_jsx(ParsedDecoratorChildren, {
        text: remainingText,
        decoratorToBeParsed: nextDecoratorName,
        isDark: isDark
      }, remainingText));
    } else {
      children.push(remainingText);
    }
  }
  return /*#__PURE__*/_jsx(Fragment, {
    children: children
  });
};
export default ParsedDecoratorChildren;